import React, { useState, useEffect } from 'react';
import Template from '../../components/Template';
import { Container, Row, Col, Card, Image, Button } from 'react-bootstrap';
import DatePicker, { registerLocale } from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import pt from "date-fns/locale/pt-BR";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { FaRegCalendarPlus } from 'react-icons/fa';
import GoogleMapReact from "google-map-react";
import './styles.css';
import useWindowDimensions from '../../helpers/GetCurrentWidth';

import StateCard from '../../components/StateCard';

import { getOsFromUser, getOsAVGRes, getOsAVGGrade } from '../../services/OsService';
import { getUsers } from '../../services/UserService';

// icons
import RegularIcon from '../../assets/icons/regular.png';
import IrregularIcon from '../../assets/icons/irregular.png';
import TotalProcessIcon from '../../assets/icons/total-process.png';
import FinishedIcon from '../../assets/icons/finished.png';
import ReviewIcon from '../../assets/icons/review.png';
import ProcessIcon from '../../assets/icons/process.png';

// Marcador do mapa
const MarkerComponent = ({ finalizado, lat, lng }: any) => {
  const classMarker = finalizado ? 'marker-success' : 'marker-warning'
  return <div className={classMarker}></div>
}



export default function RelatorioOS() {

  const [cardData, setCardData] = useState<any>();
  const [data, setData] = useState<any[]>();
  const [qtyUsers, setQtyUsers] = useState<any>({ ativo: 0, inativo: 0 });

  const [currentLat, setCurrentLat] = useState<number>(-23.8863672);
  const [currentLong, setCurrentLong] = useState<number>(-46.9771151);

  useEffect(() => {
    async function getData() {

      const cardData: any = []

      // busca dados de OS
      await getOsFromUser().then(res => {
        const dataNew = res.data.rows;
        setData(dataNew)

        // calculando indicadores
        const total = res.data.count;
        const finalizado = dataNew.filter((os: any) => os.finalizado === true).length
        const regular = dataNew.filter((os: any) => os.regularidade === 'regular').length
        const irregular = dataNew.filter((os: any) => os.regularidade === 'irregular').length

        cardData.push(
          {
            'stateNumber': total - finalizado,
            'stateContent': 'O.S. em Andamento',
            'stateIcon': ProcessIcon
          },
          {
            'stateNumber': finalizado,
            'stateContent': 'O.S. Finalizadas',
            'stateIcon': FinishedIcon
          },
          {
            'stateNumber': total,
            'stateContent': 'O.S. Total de Processos',
            'stateIcon': TotalProcessIcon
          },
          {
            'stateNumber': regular,
            'stateContent': 'O.S Regulares',
            'stateIcon': RegularIcon
          },
          {
            'stateNumber': irregular,
            'stateContent': 'O.S Irregulares',
            'stateIcon': IrregularIcon
          }
        )
      }).catch((err) => {
        cardData.push(
          {
            'stateNumber': '0',
            'stateContent': 'O.S. Finalizadas',
            'stateIcon': FinishedIcon
          },
          {
            'stateNumber': '0',
            'stateContent': 'O.S. em Andamento',
            'stateIcon': ProcessIcon
          },
          {
            'stateNumber': '0',
            'stateContent': 'O.S. Total de Processos',
            'stateIcon': TotalProcessIcon
          }
        )
        console.log(err)
      })

      // tempo medio de resolução
      await getOsAVGRes().then((res: any) => {
        let tempoResolucao = res.data[0].valor;
        tempoResolucao = (!tempoResolucao) ? '0' : tempoResolucao / 3600000 / 24;
        cardData.push({
          'stateNumber': `${tempoResolucao.toFixed(0)} dias`,
          'stateContent': 'Tempo médio de resolução',
          'stateIcon': ReviewIcon
        })
      }).catch((err) => {
        cardData.push({
          'stateNumber': `0 dias`,
          'stateContent': 'Tempo médio de resolução',
          'stateIcon': ReviewIcon
        })
      })

      // avaliação média
      await getOsAVGGrade().then(res => {
        cardData.push({
          'stateNumber': res.data[0].valor.toFixed(1),
          'stateContent': 'Avaliação Média',
          'stateIcon': ReviewIcon
        })
      }).catch(err => console.log(err))

      setCardData(cardData)
    }
    getData();

    // quantidade de usuarios
    const user: any = localStorage.getItem('user');
    const { id } = JSON.parse(user);
    getUsers(`?manager=${id}`).then(res => {
      const data = res.data.rows;
      const usersAtivo = data.filter((user: any) => user.status === true).length
      setQtyUsers({
        ativo: usersAtivo,
        inativo: data.length - usersAtivo
      })
    })

    //localização atual do usuario logado
    navigator.geolocation.getCurrentPosition(function (position) {
      const { latitude, longitude } = position.coords;
      setCurrentLat(latitude)
      setCurrentLong(longitude)
    })

  }, [])



  return (
    <Template path={'Relatório - Visão Geral'}>
      <Container className="d-block">
        <Row>
          {
            cardData && cardData.map((item: any, index: number) => {
              return <Col key={index} sm={3} md={3} lg={3}>
                <StateCard stateData={item} classInfo={{ 'padding': 'p-1', 'margin': 'ms-3' }}></StateCard>
              </Col>
            })
          }
        </Row>
        <Row className="mt-4 container-box">
          <Col md={8} lg={8} >
            <h3>O.S. por local</h3>
            <div className="w-100 position-relative" id='map'>
              {data &&
                <GoogleMapReact
                  bootstrapURLKeys={{ key: process.env.REACT_APP_API_GOOGLE || '' }}
                  defaultCenter={{
                    lat: currentLat,
                    lng: currentLong,
                  }}
                  defaultZoom={8}
                >
                  {data.map((i, index) =>
                    <MarkerComponent
                      key={index}
                      finalizado={i.finalizado}
                      lat={i.location?.geometry?.location?.lat || null}
                      lng={i.location?.geometry?.location?.lng || null}
                    />
                  )}
                </GoogleMapReact>
              }
            </div>
          </Col>

          <Col md={4} lg={4} >
            <h3>Usuário por status</h3>
            <HighchartsReact
              highcharts={Highcharts}
              options={{
                title: { text: '' },
                chart: { type: "pie", },
                series: [{
                  data: [{
                    name: 'Ativo', y: qtyUsers?.ativo || 0
                  }, {
                    name: 'Inativo', y: qtyUsers?.inativo || 0
                  },]
                }],
                credits: { enabled: false },
                colors: ['var(--color-primary)', 'var(--color-secundary)']
              }}
            />
          </Col>
        </Row>
      </Container>
    </Template >
  )
}
